import { render, staticRenderFns } from "./listRP.vue?vue&type=template&id=f9636cde&scoped=true"
import script from "./listRP.vue?vue&type=script&lang=js"
export * from "./listRP.vue?vue&type=script&lang=js"
import style0 from "./listRP.vue?vue&type=style&index=0&id=f9636cde&prod&lang=scss"
import style1 from "./listRP.vue?vue&type=style&index=1&id=f9636cde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9636cde",
  null
  
)

export default component.exports